import { graphql } from '@/gql'

export const NOTE_VIEW_FRAGMENT = graphql(/* GraphQL */`
  fragment NoteViewFragment on Note {
    id
    body
    createdAt
    updatedAt
    author {
      id
      name
      avatar
      avatarPath @client
      initials @client
    }
    viewerCanUpdate
    viewerCanDelete
  }
`)
